import { PlaceEntity } from 'src/entities/placeEntity';
import { escapeForExcelText } from 'src/utils/excelCsv.util';

/**
 * 一覧の CSV エクスポートで ="..." に囲む自由文字列の列（#362）。
 * MUI の既定（escapeFormulas）は = + - @ 始まりの値に ' を付けるので -001 のような地点コードが往復で変わる。
 * 車両一覧と同じく ="..." で囲み（Excel の 1-2 → 日付の自動変換も防ぐ）、取込側（ImportPlacesJob の
 * EXCEL_TEXT_COLUMNS）が同じ列集合で外す。列を足すときは両方を直す
 */
export const EXCEL_TEXT_FIELDS = [
  'internal_location_code', 'name', 'address', 'company_name',
  'shipper_name', 'shipper_contact_person', 'shipper_phone_number', 'shipper_email_address',
] as const;

export const escapePlaceRowsForExcel = (rows: PlaceEntity[]): PlaceEntity[] => rows.map((row) => {
  const escaped: Record<string, unknown> = { ...row };
  EXCEL_TEXT_FIELDS.forEach((field) => {
    escaped[field] = escapeForExcelText(row[field]);
  });
  return escaped as unknown as PlaceEntity;
});
